import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { KibContainer } from '@chewy/kib-layout-react'
import { NumberUtils } from '@pbt/pbt-ui-components'

import type {
  CompletedSaleTransaction,
  FailedSaleTransaction,
} from '~/api/graphql/generated/types'
import arrowImage from '~/components/common/images/arrowPaymentRequest.svg'
import catLaptopImage from '~/components/common/images/catLaptopPaymentRequest.svg'
import dogTerminalImage from '~/components/common/images/dogTerminalPaymentRequest.svg'
import { usePaymentTransactionStatus } from '~/components/dashboard/invoices/payment/add-payment-dialog-v2/hooks/usePaymentTransactionStatus'
import {
  isTransactionCompleted,
  isTransactionError,
} from '~/constants/addPaymentDialogV2Constants'

import { usePaymentDialog } from '../context/PaymentDialogProvider'

import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './PaymentRequestScreen.module.scss'

export const PaymentRequestScreen = () => {
  const { t } = useTranslation('Dialogs')
  const { dialogState, actions } = usePaymentDialog()
  const { paymentData } = dialogState
  const amountToCharge = parseFloat(paymentData.amountToCharge || '0')
  const { transaction, error } = usePaymentTransactionStatus(
    dialogState.paymentData.transactionId || '',
  )

  useEffect(() => {
    if (paymentData.transactionId && transaction) {
      if (isTransactionCompleted(transaction)) {
        actions.handleTransactionSuccess(
          paymentData,
          transaction as CompletedSaleTransaction,
        )
      } else if (isTransactionError(transaction)) {
        actions.handleTransactionFailure(transaction as FailedSaleTransaction)
      }
    } else if (paymentData.transactionId && error) {
      actions.handleTransactionHardFailure()
    }
  }, [paymentData.transactionId, transaction, error])

  return (
    <KibContainer className={styles.paymentRequestContainer}>
      <div className={styles.paymentRequestInfo}>
        <div className={styles.infoText}>
          {t('Dialogs:ADD_PAYMENT_DIALOG_V2.PAYMENT_REQUEST_INFO', {
            amount: `${NumberUtils.formatMoney(amountToCharge)}`,
            terminal: paymentData.paymentTerminal || '',
          })}
        </div>
        <div className={styles.instructionText}>
          {t('Dialogs:ADD_PAYMENT_DIALOG_V2.LOOK_FOR_TRANSACTION_ON_TERMINAL')}
        </div>
      </div>
      <div className={styles.paymentRequestImages}>
        <img
          alt="Cat with Laptop"
          className={styles.paymentImage}
          src={catLaptopImage}
        />
        <img alt="Arrow" className={styles.arrowImage} src={arrowImage} />
        <img
          alt="Dog with Terminal"
          className={styles.paymentImage}
          src={dogTerminalImage}
        />
      </div>
    </KibContainer>
  )
}
